module.exports = __webpack_public_path__ + "static/media/rnaui_105.e567e0ce.ico";